import { POST } from '@/api'
import { keyBy } from 'lodash'
import detail from './detail'
import edit from './edit'
import integration from './integration'
import syncMemberTypes from './syncMemberTypes'
import options from './options'
import csv from './csv'

export default {
  namespaced: true,
  state: {
    byId: {},
    allIds: [],
    busy: false,
    ended: false,
  },
  modules: {
    detail,
    edit,
    integration,
    syncMemberTypes,
    options,
    csv,
  },
  mutations: {
    set(state, items) {
      state.byId = keyBy(items, 'id')
      state.allIds = items.map(item => item.id)
    },
    busy(state, busy) {
      state.busy = busy
    },
    ended(state, ended) {
      state.ended = ended
    },
    clear(state) {
      state.allIds = []
      state.ended = false
    },
  },
  getters: {
    all(state) {
      return state.allIds.map(id => state.byId[id])
    },
  },
  actions: {
    async getCandidates(store, { lastNameKana, firstNameKana, lastName, firstName, tel, tel2 }) {
      const { commit, getters, state, rootState } = store
      if (state.busy || state.ended) return false
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/customer/reservation_search', {
        lastNameKana,
        firstNameKana,
        lastName,
        firstName,
        tel,
        tel2,
        start: state.allIds.length,
        limit: 20,
        storeId: rootState.stores.current.store.id,
      })
      if (status === 200) {
        commit('set', getters.all.concat(data.customer))
        if (!data.pagenation.next) commit('ended', true)
      } else {
        commit('ended', true)
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
